//Importaciones
import React from 'react';
import { Card, Row, Col } from "react-bootstrap"
import GAPElementTypeBox from '../GAPElementTypeBox';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CLabel from '../../../../Common/CLabel';
import moment from 'moment';
import { __onGoToGapV2 } from '../../../../../common/SystemRedirections';
import { ActionButton } from '@fluentui/react';

function GAPBox(props) {
    //Helpers
    const { t } = useTranslation();

    //Parametros de entrada.
    const {
        inputParam_GAPObject = null,
    inputParam_SelectedElementId = null,
        inputParam_SetterSelectedElementId = null,
        inputParam_SetterGAPElements = null,
    inputParam_GAPElementList = null,
        inputParam_SetterGapRevisionDataserieList = null,
    inputParam_FishboneList = null,
    } = props;

    //Parametros de componente.
    
    //Funciones de componente.

    //Render de componente.
    return (
        <Card className='gap-element-form h-100'>
            <Row>
                <Col>
                    <Card.Header className='card-header-compact pt-1 pb-0 px-2'>
                        <Card.Title className="d-flex justify-content-between pb-0">
                            <b>{ t('data-lang-boxname-gap') }</b>
                            <div className='book-toolbar d-flex float-end'>
                                {
                                    <ActionButton onClick={ () => __onGoToGapV2(inputParam_GAPObject.id) } iconProps={{ iconName: 'Go' }} allowDisabledFocus>
                                        { t('data-lang-lbl-gotogapv2') }
                                    </ActionButton>
                                }
                            </div>
                        </Card.Title>
                    </Card.Header>
                    <Card.Body className="board-element-form-body pt-2 w-100">
                        {
                        inputParam_GAPObject.id !== null &&
                            <>
                                <Row>
                                    <Col xs={12} xl={12}>
                                        <Row className='d-none d-sm-flex'>
                                            <Col xs={6} xl={12}>
                                                <CLabel labelText={ t('data-lang-lbl-name') } labelValue={ inputParam_GAPObject.name } />
                                            </Col>
                                            <Col xs={6} xl={6}>
                                                <CLabel labelText={ t('data-lang-lbl-creationdate') } labelValue={ moment(inputParam_GAPObject.creationDate).format('DD/MM/YYYY') } />
                                            </Col>
                                            <Col xs={6} xl={6}>
                                                <CLabel labelText={ t('data-lang-lbl-status') } labelValue={ t('data-lang-skgap-status' + inputParam_GAPObject.statusId) } />
                                            </Col>
                                        </Row>
                                        <Row className='d-flex d-sm-none'>
                                            <Col xs={7} xl={6}>
                                                <CLabel labelText={ t('data-lang-lbl-creationdate') } labelValue={ moment(inputParam_GAPObject.creationDate).format('DD/MM/YYYY') } />
                                            </Col>
                                            <Col xs={5} xl={6}>
                                                <CLabel labelText={ t('data-lang-lbl-status') } labelValue={ inputParam_GAPObject.statusId } />
                                            </Col>
                                            <Col xs={12} xl={6}>
                                                <CLabel labelText={ t('data-lang-lbl-name') } labelValue={ inputParam_GAPObject.name } />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xl={12} md={12} xs={12}>
                                    {
                                        inputParam_GAPElementList && /*inputParam_FishboneList &&*/
                                        <GAPElementTypeBox
                                            inputParam_EditMode={ true }
                                            inputParam_SelectedElementId={ inputParam_SelectedElementId }
                                            inputParam_ElementList={ inputParam_GAPElementList }
                                            inputParam_SetterGAPElements={inputParam_SetterGAPElements}
                                            inputParam_SetterSelectedElementId={inputParam_SetterSelectedElementId}
                                            inputParam_SetterGapRevisionDataserieList={inputParam_SetterGapRevisionDataserieList}
                                            inputParam_GAPId={inputParam_GAPObject.id}
                                            inputParam_FishboneList={inputParam_FishboneList}
                                            inputParam_ClickEnabled={true}
                                        />
                                    }
                                    </Col>
                                </Row>
                            </>
                        }
                    </Card.Body>
                </Col>
            </Row>
        </Card>
    );
}

///Proptypes
GAPBox.propTypes = {
    inputParam_SelectedElementId: PropTypes.number,
    inputParam_GAPObject: PropTypes.object.isRequired,
    inputParam_SetterSelectedElementId: PropTypes.func.isRequired,
    inputParam_SetterGAPElements: PropTypes.func.isRequired,
    inputParam_GAPElementList: PropTypes.array,
    inputParam_SetterGapRevisionDataserieList: PropTypes.func.isRequired,
    inputParam_FishboneList: PropTypes.array,
};

export default GAPBox;